<template>
  <div class="flex items-center">
    <vx-tooltip v-if="status !== NONE"
                :position="tooltipPosition"
                :title="tooltipTitle"
                :text="tooltipText"
                class="flex items-center"
                :enabled="true"
    >
      <component :is="statusTypeIcon" class="h-4 w-4"/>
    </vx-tooltip>
  </div>
</template>

<script>
import LoadingAnimation from '@/components/common/LoadingAnimation'
import StatusSuccessIcon from '@/assets/images/icons/StatusSuccessIcon'
import StatusErrorIcon from '@/assets/images/icons/StatusErrorIcon'
import StatusWarningIcon from '@/assets/images/icons/StatusWarningIcon'
import { getIndexGroupExecutionStatus, getSkippedProductCount } from '@/utils/index-execution.utils'

const NONE = 'none'
const DATA_PROCESSING = 'data_processing'
const FINISHED = 'finished'
const PARTIALLY_FINISHED = 'partially_finished'
const ERROR = 'error'

export default {
  name: 'IndexGroupExecutionStatusIcon',

  components: {
    LoadingAnimation,
    StatusSuccessIcon,
    StatusErrorIcon,
    StatusWarningIcon
  },

  props: {
    indexes: {
      type: Array,
      default: () => []
    },
    tooltipPosition: {
      type: String,
      default: 'top'
    }
  },

  data() {
    return {
      NONE
    }
  },

  computed: {
    status() {
      return getIndexGroupExecutionStatus(this.indexes)
    },
    // PRO-719: a market that finished but skipped products shows a warning, so the group must too
    hasSkippedProducts() {
      return this.indexes.some(index => getSkippedProductCount(index.last_index_execution))
    },
    statusTypeIcon() {
      switch (this.status) {
        case FINISHED:
          return this.hasSkippedProducts ? 'status-warning-icon' : 'status-success-icon'
        case PARTIALLY_FINISHED:
          return 'status-warning-icon'
        case ERROR:
          return 'status-error-icon'
        case DATA_PROCESSING:
          return 'loading-animation'
        default:
          return 'loading-animation'
      }
    },
    tooltipTitle() {
      switch (this.status) {
        case FINISHED:
          return 'Finished'
        case ERROR:
          return 'Error'
        case DATA_PROCESSING:
          return 'Processing'
        case PARTIALLY_FINISHED:
          return 'Partially finished'
        default:
          return 'Unknown'
      }
    },
    tooltipText() {
      switch (this.status) {
        case FINISHED:
          return this.hasSkippedProducts ?
            'All markets in this knowledge base group have completed indexing, some with skipped products.' :
            'All markets in this knowledge base group have completed indexing successfully.'
        case ERROR:
          return 'One or more markets in this group have indexing errors.'
        case DATA_PROCESSING:
          return 'One or more markets in this group are still processing.'
        case PARTIALLY_FINISHED:
          return 'One or more markets in this group finished with warnings.'
        default:
          return 'Unknown'
      }
    }
  }
}
</script>
